


















































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import CurrencyMixin from '@/components/helpers/currency-mixin';
import FlowMixin from '@/views/reports/mixins/flow/flow-mixin';

import { mixins } from 'vue-class-component';


@Component({
  components: {
  }
})
export default class CostModel extends mixins<CurrencyMixin, FlowMixin>(CurrencyMixin, FlowMixin) {
  @Prop({ default: false })
  disabled: boolean;

  @Prop({ default: [] })
  errors: [];

  @Prop({ default: 'USD' })
  currencyId: string;

  @Prop({ default: 'auto' })
  costModel: string;

  @Prop({ default: 0 })
  costValue: number;

  @Prop({ default: false })
  maximumCostAvailable: boolean;

  @Prop({ default: false })
  maxCostEnabled: boolean;

  @Prop({ default: null })
  maxCostUsd: number | null;

  @Prop({ default: 1 })
  maxCostAction: 0 | 1;

  @Prop({ default: null })
  maxCostBotOfferId: string | null;

  @Prop({ default: () => [] })
  maxCostErrors: string[];

  @Prop({ default: () => [] })
  maxCostBotOfferErrors: string[];

  onChangeCostModel(val) {
    this.costValue = 0;
    this.$emit('update:costModel', val)
    if (!['auto', 'autoCpm'].includes(val)) {
      this.maxCostEnabled = false;
    }
  }

  get isAutomaticCost() {
    return ['auto', 'autoCpm'].includes(this.costModel);
  }

  get maxCostActions() {
    return [
      {
        value: 0,
        name: this.t('Record as Bot With Bot Cost'),
        ...(!this.$store.state.user.enableBotFilters && { planLimits: 'botFiltersAccess' })
      },
      { value: 1, name: this.t('Don\'t Record Click and Cost') }
    ];
  }

  get costValueTitles() {
    return {
      cpv: this.t('CPV cost'),
      cpm: this.t('CPM cost'),
      cpa: this.t('CPA cost'),
      revShare: this.t('RevShare cost, %')
    };
  }

  get costValueLabel() {
    return this.costValueTitles[this.costModel];
  }

  get isRevShare() {
    return this.costModel === 'revShare';
  }

  get costFormat() {
    return this.isRevShare ? null : '0.000000';
  }

  get costMaxValue() {
    return this.isRevShare ? 100 : null
  }

  get costMinValue() {
    return this.isRevShare ? 0 : 0.000001
  }

  get iconCurrency() {
    return this.isRevShare ? '' : this.currencies[this.currencyId];
  }

  get iconCurrencyRevshare() {
    return this.isRevShare ? '%' : '';
  }

  @Watch('costValue')
  updateValue (value) {
    this.$emit('update:costValue', value)
  }

  @Watch('maxCostEnabled')
  updateMaxCostEnabled(value) {
    this.$emit('update:maxCostEnabled', value)
    if (!value) {
      this.maxCostUsd = null;
      this.maxCostAction = 1;
      this.maxCostBotOfferId = null;
    }
  }

  @Watch('maxCostUsd')
  updateMaxCostUsd(value) {
    this.$emit('update:maxCostUsd', value)
  }

  @Watch('maxCostAction')
  updateMaxCostAction(value) {
    this.$emit('update:maxCostAction', value)
    if (value !== 0) {
      this.maxCostBotOfferId = null;
    }
  }

  @Watch('maxCostBotOfferId')
  updateMaxCostBotOfferId(value) {
    this.$emit('update:maxCostBotOfferId', value)
  }
}
